import React, { FC } from 'react';
import cx from 'classnames';
import { SwitchChangeEventHandler } from 'antd/lib/switch';
import Switch from '../../input/Switch';
import './SwitchForm.scss';

interface SwitchFormProps {
  className?: string;
  label?: string;
  checked?: boolean;
  onChange?: SwitchChangeEventHandler;
  disabled?: boolean;
}

const SwitchForm: FC<SwitchFormProps> = (props) => {
  const { className, label, checked = false, onChange, disabled = false } = props;
  return (
    <div className={cx('switch-form', 'amondz-form', className, { 'with-label': label })}>
      {label ? (
        <div className="ant-form-item-label">
          <label>{label}</label>
        </div>
      ) : null}

      <div className="content">
        <Switch checked={checked} onChange={onChange} disabled={disabled} />
      </div>
    </div>
  );
};

export default SwitchForm;
